<template>
  <div class="d-flex align-center">
    <div class="d-flex">
      <v-tooltip top>
        {{ $t('rev.header.like_rev') }}
      </v-tooltip>
      <v-tooltip v-for="option in iconOptions" v-bind:key="option.id" top>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            class="mr-2"
            v-on="on"
            :data-testid="option.tid"
            @click="optionClicked(option.id)"
          >
            <v-icon color="white" size="20">
              {{ option.icon }}
            </v-icon>
          </v-btn>
        </template>
        {{ option.label }}
      </v-tooltip>
    </div>
    <ContextualMenu
      dotsColor="white"
      tid="revHeader-contextualMenu"
      data-testid="revHeader-contextualMenu"
      data-tourid="revHeader-button-contextualMenu"
      :options="menuOptions"
      @openMenu="onOpenMenu"
      @optionClicked="optionClicked"
    />
  </div>
</template>
<script>
import trackerMixin from '@/mixins/tracking/trackerMixin.vue'

import ContextualMenu from '@/components/Core/ContextualMenu.vue'

export default {
  mixins: [trackerMixin],
  components: {
    ContextualMenu,
  },
  props: {
    isLiked: {
      type: Boolean,
      required: true,
      default: false,
    },
    iconOptions: {
      type: Array,
      required: true,
      default: function() {
        return []
      },
    },
    menuOptions: {
      type: Array,
      required: true,
      default: function() {
        return []
      },
    },
    likeTid: {
      type: String,
      required: false,
      default: 'like',
    },
    likedTid: {
      type: String,
      required: false,
      default: 'liked',
    },
    isTranslationEnabled: {
      type: Boolean,
      required: false,
      default: false,
    },

    rev: {
      type: Object,
      required: false,
    },
  },
  methods: {
    onOpenMenu() {
      this.trackOpenContextualMenu({
        revId: this.rev?.id,
        revType: this.rev?.type,
      })
    },
    optionClicked(id) {
      this.$emit('optionClicked', id)
    },
    like() {
      this.$emit('like')
    },
    unlike() {
      this.$emit('unlike')
    },
  },
}
</script>
